import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ServicoAutenticacao } from './core/auth/servico-autenticacao';
import { ServicoTenant } from './core/tenant/servico-tenant';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(ServicoAutenticacao).token;
  const servicoTenant = inject(ServicoTenant);
  const url = req.url.toLowerCase();
  const rotaPublica = url.includes('/api/public/') || url.endsWith('/api/public/tenant');
  const rotaAutenticacao = url.includes('/api/auth/login') || url.includes('/api/auth/bootstrap');
  const headers: Record<string, string> = {};

  if (servicoTenant.slugTenantAtual) {
    headers['X-Tenant-Host'] = servicoTenant.hostAtual;
  }

  if (token && !rotaPublica && !rotaAutenticacao) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (Object.keys(headers).length === 0) {
    return next(req);
  }

  return next(req.clone({ setHeaders: headers }));
};
